import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon4 from "../assets/img/nav-icon4.svg";



const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/* <MailchimpForm /> */}
          <Col size={12} sm={6}>
            {/* <img src={logo} alt="Logo" /> */}
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon mt-2">
              <a href='https://www.linkedin.com/in/akshay-shrivastava-b63231172/' target="_blank" rel="noopener noreferrer"><img src={navIcon1} alt="Icon" /></a>
              <a href='https://github.com/akshim1702' target="_blank" rel="noopener noreferrer"><img src={navIcon4} alt="" /></a>

            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer